import { useMemo } from 'react';
import { IMeasureFilterValue } from '../../../../../../redux/slices/oldBuilder';
import {
  defaultMeasureFilterState,
  defaultSingleMeasureFilter,
  IMeasureFilterState,
} from '../types';
import { DefaultValues } from 'react-hook-form';
import { RelationalOperatorKey } from '../../../../../../utils/apollo/graphqlSchema';
import { assertNotNil } from '../../../../../../utils/types';

const useDefaultMeasureFilterValues = (
  defaultValues: IMeasureFilterValue[],
  defaultMeasureKey?: string,
): DefaultValues<IMeasureFilterState> =>
  useMemo(() => {
    if (!defaultValues.length && !defaultMeasureKey) {
      return defaultMeasureFilterState;
    }

    if (defaultMeasureKey) {
      return {
        filters: [
          {
            ...defaultSingleMeasureFilter,
            measureKey: defaultMeasureKey,
          },
        ],
      };
    }

    return {
      filters: defaultValues.map((defaultValue) => {
        const { measureKey, filter } = defaultValue;

        assertNotNil(filter);

        const { relOp, values } = filter;

        const relOpKey = relOp.key;

        if (relOpKey === RelationalOperatorKey.Between) {
          const [fromValue, toValue] = values;

          return {
            measureKey,
            relOpKey,
            value: null,
            fromValue,
            toValue,
          };
        } else {
          return {
            measureKey,
            relOpKey,
            value: values[0],
            fromValue: null,
            toValue: null,
          };
        }
      }),
    };
  }, [defaultMeasureKey, defaultValues]);

export default useDefaultMeasureFilterValues;
